import { useQuery } from "react-query";
import api from "../api";

export const useGetKycUser = () => {
  return useQuery(["kyc_user"], () => {
    return api.get("/kyc").then((res) => res.data);
  });
};
